import { Button } from '@repo/videa-components';

import configs from '@/config';
import { trackPreQualifyEvent } from '@/modules/preQualify/trackPreQualifyEvent';
import { endpoints } from '@/react-query/endpoints';
import { mixpanelEvents } from '@/utils/mixpanel';

interface DownloadSectionProps {
  show: boolean;
  dealId: string;
}

export const DownloadSection = ({ show, dealId }: DownloadSectionProps) => {
  if (!show) {
    return null;
  }

  const handleDownload = () => {
    trackPreQualifyEvent(dealId, mixpanelEvents.preQualifyDownloadClick, {
      dealId,
    });
    window.open(
      `${configs.CONNECTOR_API_URL}/${endpoints.connector.downloadCompatibility}?code=${dealId}`,
      '_blank',
    );
  };

  return (
    <div className="vai-space-y-2">
      <p className="vai-text-center vai-text-sm vai-text-gray-500">
        Download the pre-qualifier to assess system compatibility and image
        quality.
      </p>
      <Button
        onClick={handleDownload}
        className="vai-w-full vai-bg-teal-600 hover:vai-bg-teal-700"
      >
        Download Pre-Qualifier
      </Button>
    </div>
  );
};
